export default __webpack_public_path__ + "static/caixa2-71bbabb7dba24dd7f2611e2c1fa6b143.webp";